function Contact() {
    return (
      <section id="contact" className="section">
        <h2>Contact</h2>
  
        <div className="contact-content">
          <p>
            I am currently looking for opportunities to grow as a Junior DevOps or
            Cloud Engineer. Feel free to contact me or check my work online.
          </p>
  
          <div className="contact-links">
            <a href="mailto:your-email@example.com">Email Me</a>
  
            <a
              href="https://github.com/yourusername"
              target="_blank"
              rel="noreferrer"
            >
              GitHub
            </a>
  
            <a
              href="https://linkedin.com/in/yourprofile"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </section>
    );
  }
  
  export default Contact;